import { render, staticRenderFns } from "./newsFrom.vue?vue&type=template&id=348653cc"
import script from "./newsFrom.vue?vue&type=script&lang=js"
export * from "./newsFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348653cc')) {
      api.createRecord('348653cc', component.options)
    } else {
      api.reload('348653cc', component.options)
    }
    module.hot.accept("./newsFrom.vue?vue&type=template&id=348653cc", function () {
      api.rerender('348653cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/templateManage/templateFrom/newsFrom.vue"
export default component.exports